var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"b-container",attrs:{"fluid":""}},[_c('v-sheet',{staticClass:"pa-3",staticStyle:{"overflow":"auto"},attrs:{"outlined":""}},[_c('PointTiers',{attrs:{"tiers":_vm.tiers}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }